import Main from './Main.vue'
import Users from './Users.vue'
import Roles from './Roles.vue'
import Billing from './Billing.vue'
import Credits from './Credits.vue'
import Products from './Products.vue'
import Database from './Database.vue'

const routes = [
  { name: 'administration/main', component: Main, path: '/administration' },
  {
    name: 'administration/users',
    component: Users,
    path: '/administration/users',
  },
  {
    name: 'administration/roles',
    component: Roles,
    path: '/administration/roles',
  },
  {
    name: 'administration/billing',
    component: Billing,
    path: '/administration/billing',
  },
  {
    name: 'administration/credits',
    component: Credits,
    path: '/administration/credits',
  },
  {
    name: 'administration/products',
    component: Products,
    path: '/administration/products',
  },
  {
    name: 'administration/database',
    component: Database,
    path: '/administration/database',
  },
]

export { routes }
